import { createContext, useContext } from "react";

/**
 * True while the module editor is open as the large modal (⤢ in the drawer
 * header) instead of the side panel. Editors use it to give their main text
 * box more room.
 */
export const EditorExpandedContext = createContext(false);

export function useEditorExpanded(): boolean {
  return useContext(EditorExpandedContext);
}
